import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getToken, getProfileData } from '../../store/auth/selectors';

const ChatWidget = ({ agentId }) => {

    const ref = useRef(null);
    const token = useSelector(getToken);            // { accessToken, idToken }
    const profileData = useSelector(getProfileData); // account.options.profile
    const accessToken = token?.accessToken;

    // Provide the JWT to the widget once the user is authenticated.
    useEffect(() => {
        const widget = ref.current;
        if (widget && accessToken) {
            widget.setAttribute('external-token', accessToken);
        }
    }, [accessToken]);

    // Provide the logged-in user's profile context to the widget.
    useEffect(() => {
        const widget = ref.current;
        if (widget && typeof widget.setContext === 'function') {
            widget.setContext(profileData);
        }
    }, [profileData]);

    return (
        <floating-chat-widget
            ref={ref}
            organization-slug="veronafiere"
            agent-id={agentId}
            await-external-token={!!accessToken}
        />
    );

};

export default ChatWidget;
